export default __webpack_public_path__ + "static/media/920.f2a89306.gif";